<template>
	<div>
		<div class="flex flex-col justify-center mt-10" v-if="show && !overlay">
			<div class="rounded-md p-4 max-w-sm w-full mx-auto">
				<h3 class="text-md text-gray-400 text-md font-semibold mb-4">{{ text }}</h3>
				<div class="animate-pulse flex space-x-4">
					<div class="flex-1 space-y-4 py-1">
						<div class="h-4 bg-gray-300 rounded w-3/4"></div>
						<div class="space-y-2">
							<div class="h-4 bg-gray-300 rounded"></div>
							<div class="h-4 bg-gray-300 rounded w-5/6"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full h-full fixed block top-0 left-0 bg-white opacity-70 z-50" v-if="show && overlay">
			<span class="text-blue-500 opacity-60 top-1/2 my-0 mx-auto block relative w-0 h-0">
				<svg class="-mt-20 animate-spin h-20 w-20 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
					<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
					<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
				</svg>
				<h1 class="text-base text-gray-800 mt-6">{{ overlayText ? overlayText : 'Aguarde' }}</h1>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Loading',
	props: {
		text: String,
		show: Boolean,
		overlay: Boolean,
		overlayText: String
	}
}
</script>